__turbopack_context__.v({
  "danger": "Badge-module__UORuMW__danger",
  "primary": "Badge-module__UORuMW__primary",
  "root": "Badge-module__UORuMW__root",
  "success": "Badge-module__UORuMW__success",
  "warning": "Badge-module__UORuMW__warning",
});
